export const styles = theme => ({

	root: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly',
	},

	icon: {
		color: '#009AC9',
		cursor: 'pointer',
	},

});

export default styles;